import React, { useEffect, useState } from "react";
import { ISSUE_ACTION_RES_OPTIONS, ISSUE_ACTION_RES_TYPES } from "../../js/defineTdm";
import { successfulAction } from "../../js/issues/IssueActionsCtrls";
import { IssueService } from "../../js/issues/issueService";
import { IssueResolveAsExpiredProps } from "../../js/headersegment/interfaces";

const IssueResolveAsExpired: React.FC<IssueResolveAsExpiredProps> = ({ issueUpdated, issue }) => {
  const [resolution, setResolution] = useState<string | null>(null);
  const [resolutionOptions, setResolutionOptions] = useState<{ name: string; value: string }[]>([]);
  const [extraMinutesAdded, setExtraMinutesAdded] = useState<string | null>(null);
  const [comment, setComment] = useState<string>("");

  useEffect(() => {
    const options: { name: string; value: string }[] = [];
    if (ISSUE_ACTION_RES_OPTIONS.expired) {
      for (const [key, value] of Object.entries(ISSUE_ACTION_RES_OPTIONS.expired)) {
        options.push({ name: value, value: key });
      }
    }
    setResolutionOptions(options);

    return () => {
      setResolutionOptions([]);
    };
  }, []);

  const handleResolve = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data = await IssueService.resolve(
        [
          {
            id: issue.id,
            tripId: issue.tripId,
          },
        ],
        {
          type: ISSUE_ACTION_RES_TYPES.expired,
          subResolution: resolution,
          extraMinutesAdded,
        },
        comment
      );
      if (successfulAction(data!)) {
        issueUpdated({
          tripId: issue.tripId as string,
          issueId: issue.id as string,
        });
      }
    } catch (error) {
      console.error("Error resolving issue as expired:", error);
    }
  };

  return (
    <div className="issue-resolution" onClick={(e) => {e.stopPropagation();}}>
      <form role="form" noValidate onSubmit={handleResolve}>
        <div className="content">
          <div className="choices">
            <div className="row">
              <div className="col-md-3 fs-label fs-label-hxs">SUB RESOLUTION</div>
              <div className="col-md-9 left">
                {resolutionOptions.map((option, index) => (
                  <div className="col-md-6" key={index}>
                    <input
                      type="radio"
                      name="subRes"
                      value={option.value}
                      checked={resolution === option.value}
                      onChange={(e) => setResolution(e.target.value)}
                    />{" "}
                    {option.name}
                  </div>
                ))}
              </div>
            </div>
            <div className="row field-sep">
              <div className="col-md-3 fs-label fs-label-hxs">FURTHER DETAILS</div>
              <div className="col-md-9 left">
                <div className="row">
                  <div className="col-md-6">
                    <div className="col-sm-6">Extra Mins Added</div>
                    <div className="col-md-6">
                      <input
                        type="number"
                        maxLength={4}
                        value={extraMinutesAdded || ''}
                        onChange={(e) => setExtraMinutesAdded(e.target.value || null)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row field-sep">
              <div className="col-md-3 fs-label fs-label-hxs">COMMENT</div>
              <div className="col-md-9">
                <textarea
                  className="text-area"
                  id="comment"
                  rows={5}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  required
                ></textarea>
              </div>
            </div>
          </div>

          <div className="action">
            <button
              type="submit"
              className="btn btn-default button-action"
            >
              RESOLVE
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default IssueResolveAsExpired;